import React, { forwardRef } from 'react';
import { observer } from 'mobx-react-lite';
import { CheckIcon, MinusIcon } from 'lucide-react';
import { cn } from 'src/domains/common/components/utils';
import { CheckboxPropsType } from 'src/domains/common/components/checkbox/checkbox.type';

export const Checkbox = observer(
    forwardRef<HTMLInputElement, CheckboxPropsType>(
        ({ checked, className, dataTest, indeterminate, isDisabled, label, onChange, ...props }, ref) => {
            return (
                <label
                    className={cn(
                        'cursor-pointer flex items-center pointer-events-none',
                        isDisabled === true && 'opacity-50 cursor-not-allowed',
                        className
                    )}
                >
                    <input
                        checked={checked}
                        className='hidden'
                        data-test={dataTest}
                        disabled={isDisabled}
                        onChange={onChange}
                        type='checkbox'
                        ref={ref}
                        {...props}
                    />
                    <span
                        className={cn(
                            'w-4 h-4 inline-block border border-solid border-primary rounded-sm bg-background relative mr-2 pointer-events-auto',
                            checked && 'bg-primary'
                        )}
                    >
                        {checked && indeterminate !== true && (
                            <CheckIcon className='absolute inset-0 w-full h-full text-primary-foreground' />
                        )}

                        {indeterminate === true && (
                            <MinusIcon className='absolute inset-0 w-full h-full text-primary-foreground' />
                        )}
                    </span>
                    <span className='pointer-events-auto'>{label}</span>
                </label>
            );
        }
    )
);
